import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, CheckIcon } from 'lucide-react';
const proofs = ['Dominio propio incluido', 'Optimizada para celulares', 'Sin reuniones'];
export function Hero() {
  return <section id="top" className="relative w-full overflow-hidden bg-white" data-id="element-89" data-mp="9lv00naxu9u9">
      <div aria-hidden="true" className="pointer-events-none absolute -right-32 -top-40 h-[28rem] w-[28rem] rounded-full bg-brand-yellow/20 blur-3xl" data-id="element-90" data-mp="4m8m0bnacpke" />
      <div className="mx-auto grid w-full max-w-6xl items-center gap-14 px-5 pb-20 pt-16 sm:px-8 lg:grid-cols-2 lg:gap-10 lg:pb-28 lg:pt-24" data-id="element-91" data-mp="1274l9hahx23j">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-92" data-mp="sa9r1al99nv2">
          <span className="inline-flex items-center gap-2 rounded-full border border-brand-yellow bg-brand-yellowSoft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-brand-ink" data-id="element-93" data-mp="3d21t5zvq8oos">
            <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-94" data-mp="3j8sfs1yzrlqd" />
            Entrega en 24 horas
          </span>

          <h1 className="mt-6 text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl" data-id="element-95" data-mp="3o7vj9hzbpjw8">
            Tu página web profesional lista en solo{' '}
            <span className="relative inline-block" data-id="element-96" data-mp="3e9frdcsh26lo">
              <span className="relative z-10" data-id="element-97" data-mp="3e84m18jdoqsg">24 horas</span>
              <span aria-hidden="true" className="absolute inset-x-0 bottom-1 z-0 h-3 rounded-sm bg-brand-yellow sm:h-4" data-id="element-98" data-mp="30iawsp3yo4i7" />
            </span>
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-brand-ink/60" data-id="element-99" data-mp="2qkdd8ex1qvvx">
            Diseño moderno, dominio propio, optimizada para celulares y lista para recibir clientes
            desde mañana.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-100" data-mp="2hk86m6zog1it">
            <a href="#planes" className="inline-flex items-center justify-center rounded-full bg-brand-yellow px-8 py-4 text-base font-bold text-brand-ink shadow-soft transition-transform hover:-translate-y-0.5" data-id="element-101" data-mp="2lkimqch6o8be">
              Quiero mi página
            </a>
            <a href="#ejemplos" className="inline-flex items-center justify-center rounded-full border border-black/10 bg-white px-8 py-4 text-base font-bold text-brand-ink transition-colors hover:bg-black/[0.03]" data-id="element-102" data-mp="ibypocqjh226">
              Ver ejemplos
            </a>
          </div>

          <ul className="mt-9 flex flex-wrap gap-x-6 gap-y-3" data-id="element-103" data-mp="161jbd3e2udf5">
            {proofs.map(proof => <li key={proof} className="flex items-center gap-2 text-sm font-medium text-brand-ink/60" data-id="element-104" data-mp="111yagnfcjuzs">
                <CheckIcon className="h-4 w-4 text-brand-ink" aria-hidden="true" data-id="element-105" data-mp="x0306tffu79v" />
                {proof}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.15,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative" data-id="element-106" data-mp="3hrllakmueba1">
          <div className="overflow-hidden rounded-4xl bg-[#fafafa] shadow-lift" data-id="element-107" data-mp="21bplrecubp0o">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/f03dd22e-0187-46c8-9b1c-11316e26559a.jpg" alt="Notebook y celular mostrando una página web moderna diseñada por WEB24HS" className="h-full w-full object-cover" loading="eager" data-id="element-108" data-mp="269r2vtqphe9i" />
          </div>
          <div className="absolute -bottom-5 left-5 flex items-center gap-3 rounded-2xl border border-black/5 bg-white px-5 py-3 shadow-lift sm:left-8" data-id="element-109" data-mp="2kx2h63e9vcdb">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-yellow" data-id="element-110" data-mp="2tztu67msqg72">
              <ZapIcon className="h-4 w-4 text-brand-ink" aria-hidden="true" data-id="element-111" data-mp="un99dmcnkhem" />
            </span>
            <span className="text-sm font-bold leading-tight" data-id="element-112" data-mp="zkr8kl0vbi9f">
              Publicada mañana
              <span className="block text-xs font-medium text-brand-ink/50" data-id="element-113" data-mp="4auomquckzns">Dominio propio incluido</span>
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}